import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { NgIf, NgFor } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { L10nPipe } from 'src/app/helpers/pipes/L10n.pipe';

export const defaultDialogConfig = {
  maxWidth: 960,
  maxHeight: '80vh',
  minHeight: 200,
  panelClass: 'custom-dialog',
  autoFocus: false,
  enterAnimationDuration: '0ms',
  exitAnimationDuration: '0ms',
  closeOnNavigation: true
};

export interface DialogDataModel {
  isClosable: boolean;
  title: string;
  messages: string[];
  actions?: {
    btnClass: string;
    title: string;
    confirmAction?(): void;
  }[];
}

@Component({
    selector: 'rg-modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.scss'],
    imports: [NgIf, MatDialogClose, MatDialogTitle, CdkScrollable, MatDialogContent, NgFor, MatDialogActions, L10nPipe]
})
export class RgModalComponent {
  @ViewChild('content') content!: TemplateRef<any>;
  dialogRef!: MatDialogRef<RgModalComponent>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataModel
  ) {}

  close(): void {
    this.dialogRef?.close();
  }
}
